import React from 'react';

// Envuelve React.lazy para recuperarse de un "ChunkLoadError".
//
// Cuando se hace deploy de una versión nueva, los chunks (JS/CSS) cambian de hash.
// Una pestaña abierta con la versión vieja intenta cargar un chunk que ya no existe
// y falla con ChunkLoadError, dejando la vista colgada en <Suspense>.
//
// Estrategia: si un import() falla, recargamos la página UNA sola vez (marcado en
// sessionStorage). Al recargar, el Service Worker sirve el index.html fresco
// (network-first) que apunta a los chunks nuevos. Si tras recargar vuelve a fallar,
// propagamos el error para que lo capture el ErrorBoundary y no entrar en bucle.
export default function lazyWithRetry(importFn, chunkKey) {
  return React.lazy(async () => {
    const storageKey = `chunk-reload:${chunkKey || importFn.toString().slice(0, 64)}`;
    try {
      const component = await importFn();
      // Carga exitosa: limpiar la marca de reintento.
      try { window.sessionStorage.removeItem(storageKey); } catch (_) {}
      return component;
    } catch (error) {
      let alreadyReloaded = false;
      try {
        alreadyReloaded = window.sessionStorage.getItem(storageKey) === '1';
      } catch (_) {}

      if (!alreadyReloaded) {
        try { window.sessionStorage.setItem(storageKey, '1'); } catch (_) {}
        // Recarga forzada para obtener el index.html y los chunks nuevos.
        window.location.reload();
        // Devolvemos una promesa que nunca resuelve: la página se está recargando.
        return new Promise(() => {});
      }

      // Ya recargamos una vez y sigue fallando: propagar al ErrorBoundary.
      throw error;
    }
  });
}
